import { render } from "./TechnicalModel.vue?vue&type=template&id=2e5d54fa&scoped=true"
import script from "./TechnicalModel.vue?vue&type=script&lang=js"
export * from "./TechnicalModel.vue?vue&type=script&lang=js"

import "./TechnicalModel.vue?vue&type=style&index=0&id=2e5d54fa&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5d54fa"]])

export default __exports__